export default function Home(){
    return(
        <>
            <img src={process.env.PUBLIC_URL+"/image/bunny-website.webp"} />
        </>
    )
}